<template>
    <div>
        <div class="fw-bold">
            {{ tagDisplay }}
        </div>
        <div v-if="!tagOnly">
            <div>
                {{ recipientDisplay }}
            </div>
            <div>
                <span v-bind:class="statusClass">
                    {{ recipientStatus }}
                </span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            recipient: { type: Object, required: true },
            tagOnly: { type: Boolean, required: false, default: false }
        },
        computed: {
            tagDisplay() {
                return this.recipient.SignatoryTags.join(", ");
            },
            recipientDisplay() {
                return `${this.recipient.FirstName} ${this.recipient.LastName} (${this.recipient.Email})`;
            },
            recipientStatus() {
                return this.recipient.Status.Display;
            },
            statusClass() {
                return this.recipient.Status.IsReady ? "text-bubble-success" : "text-bubble-danger";
            }
        }
    };
</script>
